import * as AlertBarState from '../../components/alert-bar/AlertBar.state';
import TerminalLoginForm from './TerminalLoginForm';
import * as Nested from '../../utils/Nested';
import { LOGOUT } from '../../state/reducer';

export const SUBMIT_TERMINAL_LOGIN_FORM =
  'terminalLogin/SUBMIT_TERMINAL_LOGIN_FORM';
export const submitTerminalLoginForm = (data) => ({
  type: SUBMIT_TERMINAL_LOGIN_FORM,
  payload: data,
});

export const TERMINAL_LOGIN_SUCCESS = 'terminalLogin/LOGIN_SUCCESS';
export const terminalLoginSuccess = (data) => ({
  type: TERMINAL_LOGIN_SUCCESS,
  payload: data,
});

const TERMINAL_LOGIN_FAILURE = 'terminalLogin/LOGIN_FAILURE';
export const terminalLoginFailure = (error) => ({
  type: TERMINAL_LOGIN_FAILURE,
  payload: { error },
});

export const FETCH_LOCATIONS = 'terminalLogin/FETCH_LOCATIONS';
export const fetchLocations = (payload) => ({
  type: FETCH_LOCATIONS,
  payload,
});

export const FETCH_LOCATIONS_SUCCESS = 'terminalLogin/FETCH_LOCATIONS_SUCCESS';
export const fetchLocationsSuccess = (payload) => ({
  type: FETCH_LOCATIONS_SUCCESS,
  payload,
});

export const FETCH_LOCATIONS_FAILURE = 'terminalLogin/FETCH_LOCATIONS_FAILURE';
export const fetchLocationsFailure = (payload) => ({
  type: FETCH_LOCATIONS_FAILURE,
  payload,
});

export const FETCH_TERMINALS = 'terminalLogin/FETCH_TERMINALS';
export const fetchTerminals = (locationId) => ({
  type: FETCH_TERMINALS,
  payload: locationId,
});

export const FETCH_TERMINALS_SUCCESS = 'terminalLogin/FETCH_TERMINALS_SUCCESS';
export const fetchTerminalsSuccess = (payload) => ({
  type: FETCH_TERMINALS_SUCCESS,
  payload,
});

export const FETCH_TERMINALS_FAILURE = 'terminalLogin/FETCH_TERMINALS_FAILURE';
export const fetchTerminalsFailure = (err) => ({
  type: FETCH_TERMINALS_FAILURE,
  payload: err,
});

export const OPEN_SESSION_TRANSFER_MODAL = 'OPEN_SESSION_TRANSFER_MODAL';
export const CLOSE_SESSION_TRANSFER_MODAL = 'CLOSE_SESSION_TRANSFER_MODAL';
export const sessionTransferModal = (type) => ({
  type,
});

const initialState = {
  submitting: false,
  error: false,
  clientId: null,
  locations: {
    fetching: false,
    data: [],
    selectedLocation: {},
  },
  terminals: {
    fetching: false,
    data: [],
  },
  terminalSession: null,
  isSessionTransferModalOpen: false,
};

const loadInitialState = () => {
  try {
    const terminalSessionState = localStorage.getItem('terminalSession');
    if (!terminalSessionState) return initialState;
    else return JSON.parse(localStorage.getItem('terminalSession'));
  } catch (err) {
    return initialState;
  }
};

export const _reducer = (state = loadInitialState(), { type, payload }) => {
  switch (type) {
    case FETCH_LOCATIONS:
      return {
        ...state,
        locations: {
          fetching: true,
          data: [],
        },
      };
    case FETCH_LOCATIONS_SUCCESS:
      return {
        ...state,
        locations: {
          fetching: false,
          data: [...payload.data],
        },
      };
    case FETCH_LOCATIONS_FAILURE:
      return {
        ...state,
        locations: {
          fetching: false,
          ...state.locations,
        },
      };
    case FETCH_TERMINALS:
      return {
        ...state,
        terminals: {
          ...state.terminals,
          fetching: true,
        },
      };
    case FETCH_TERMINALS_SUCCESS:
      return {
        ...state,
        terminals: {
          fetching: false,
          data: [...payload.data],
        },
      };
    case FETCH_TERMINALS_FAILURE:
      return {
        ...state,
        terminals: {
          fetching: false,
          ...state.terminals,
        },
      };
    case SUBMIT_TERMINAL_LOGIN_FORM:
      return { ...state, submitting: true };
    // would be namespaced under 'terminalLogin'
    case TERMINAL_LOGIN_SUCCESS:
      const { client_id, location } = payload.terminal_session;
      return {
        ...state,
        clientId: client_id,
        terminalSession: payload.terminal_session,
        locations: {
          ...state.locations,
          selectedLocation: state.locations.data.find(
            (l) => l.name === location,
          ),
        },
        submitting: false,
        error: false,
      };
    case TERMINAL_LOGIN_FAILURE:
      return {
        ...state,
        submitting: false,
        error: payload,
        terminals: {
          ...state.terminals,
          fetching: false,
        },
        locations: {
          ...state.locations,
          fetching: false,
        },
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    case OPEN_SESSION_TRANSFER_MODAL:
      return {
        ...state,
        isSessionTransferModalOpen: true,
      };
    case CLOSE_SESSION_TRANSFER_MODAL:
      return {
        ...state,
        isSessionTransferModalOpen: false,
      };
    default:
      return state;
  }
};

export const _mapStateToProps = (state) => ({
  ...state.terminalLogin,
});

export const _mapDispatchToProps = (dispatch) => ({
  fetchLocations: (payload) => dispatch(fetchLocations(payload)),
});

export const TERMINAL_ALERT_BAR_ACTION = 'terminalLogin/ALERT_BAR_ACTION';
export const terminalLoginAlertBarAction = Nested.nestedAction(
  TERMINAL_ALERT_BAR_ACTION,
);

export const TERMINAL_LOGIN_FORM_ACTION = 'terminalLogin/LOGIN_FORM_ACTION';
export const terminalLoginFormAction = Nested.nestedAction(
  TERMINAL_LOGIN_FORM_ACTION,
);

const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    forms: {
      terminalLoginForm: {
        ...TerminalLoginForm,
        actionType: TERMINAL_LOGIN_FORM_ACTION,
      },
    },
    alertBars: {
      terminalLoginAlertBar: {
        ...AlertBarState,
        actionType: TERMINAL_ALERT_BAR_ACTION,
      },
    },
  },
  'terminalLogin',
);

const reducer = (state, action) => nestedReducer(state, action);
export { reducer, mapStateToProps, mapDispatchToProps, actions };
